import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { motion } from 'framer-motion';

const faqs = [
  {
    q: 'Is this therapy or coaching?',
    a: "This is performance coaching, not therapy. We work on confidence, focus, routines, and pressure management \u2014 not trauma, diagnosis, or clinical mental health. If you need clinical support, I'll connect you with a licensed professional.",
  },
  {
    q: 'What age levels do you work with?',
    a: 'I work with middle school, high school, and college athletes. The frameworks are sport-agnostic and work for any competitive athlete who wants to perform better under pressure.',
  },
  {
    q: 'How many sessions do most athletes need?',
    a: 'Most athletes start with 3\u20136 sessions over 8\u201312 weeks. Some need just a few sessions to build a routine; others want ongoing support through a season. We figure out the right fit on the Discovery Call.',
  },
  {
    q: 'Do you work with teams and schools?',
    a: 'Yes. I offer 60\u201390 minute team workshops on confidence, focus, resilience, and team culture. Multi-session packages are available. Reach out for team pricing and availability.',
  },
  {
    q: 'Can parents attend or observe sessions?',
    a: 'Yes. Parent involvement is often helpful, especially for middle school and younger high school athletes. We can also do separate parent consultations to align on support strategies.',
  },
  {
    q: "What if my athlete isn't ready to commit?",
    a: "Start with the free quiz and PDF playbook. That gives you tools to try without any commitment. If it's a fit, you can book a Discovery Call when you're ready.",
  },
];

const fadeIn = {
  initial: { opacity: 0, y: 14 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-30px' },
  transition: { duration: 0.5 },
};

export const FAQSection = () => {
  return (
    <section
      id="faq"
      className="py-16 sm:py-20 bg-white"
      data-testid="faq-section"
    >
      <div className="max-w-[680px] mx-auto px-5 sm:px-6">
        <motion.div {...fadeIn} className="text-center mb-8">
          <div className="font-mono-accent uppercase tracking-[0.2em] text-[10px] text-[#004C54] font-semibold mb-2">
            FAQ
          </div>
          <h2 className="font-heading text-[1.65rem] sm:text-3xl font-bold tracking-tight text-[#1a1a1a] dark:text-white">
            Common Questions
          </h2>
        </motion.div>

        <motion.div {...fadeIn}>
          <Accordion type="single" collapsible className="space-y-2">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={faq.q}
                value={`item-${i}`}
                className="bg-[#F6F7F8] border border-border/30 rounded-xl px-4 sm:px-5 data-[state=open]:bg-white data-[state=open]:shadow-sm data-[state=open]:border-border/50"
              >
                <AccordionTrigger
                  className="text-left text-[13px] sm:text-sm font-semibold text-[#1a1a1a] dark:text-white hover:no-underline py-3.5 sm:py-4"
                  data-testid={`faq-item-trigger-${i}`}
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[13px] text-[#004C54] leading-relaxed pb-4">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
